import BaseScreen from "../BaseScreen";
import { Text, View } from "react-native";
import { ButtonView } from "../../components/ButtonView";
import { color_333333, color_main } from "../../assets/style/colors";
import { MainNavProps } from "../navigation/main/MainParamList";
import {Str_Cancel, Str_Complete, Str_GroupChatIntervalTime, Str_SetSendMsgInterval} from "../../language/string_res";

export function SendChatTimeSetting({navigation}:MainNavProps<'SendChatTimeSetting'>) {
  return (<BaseScreen styles={{ backgroundColor: "white", alignItems: "center" }}>
    <View style={{ height: 48, flexDirection: "row", alignItems: "center", width: "100%" }}>
      <ButtonView
        onPress={navigation.goBack}
        style={{ paddingVertical: 10 }}
        text={Str_Cancel}
        textStyle={{ color: "#334F6C", fontSize: 17, paddingHorizontal: 16 }} />
      <ButtonView
        style={{
          backgroundColor: color_main,
          borderRadius: 5,
          paddingHorizontal: 12,
          paddingVertical: 10,
          position: "absolute",
          end: 16
        }}
        text={Str_Complete}
        textStyle={{ color: "white", fontSize: 14, fontFamily:'', fontWeight: "bold" }} />
    </View>
    <Text style={{ fontSize: 23,color:color_333333, marginTop: 36, fontFamily:'', fontWeight: "bold" }}>{Str_GroupChatIntervalTime}</Text>

  </BaseScreen>);
}
